import React, { Component } from "react";
import { Redirect, Route } from "react-router-dom";
import { get, pickBy } from "lodash";
// import permissions from "./permissions";
// import {updateToken}  from './request'
const getArr = (obj, ltr) => get(obj, ltr) || [];

const getUser = () => {
  const storedUser = localStorage.getItem("user");
  if (!storedUser) return null;
  // console.log(storedUser, "stored Users");

  return JSON.parse(storedUser);
};

const logout = () => {
  localStorage.clear();
};

const getAccessToken = () => get(getUser(), "token");

const getGroups = () => getArr(getUser(), "groups");

const isPalikaAdmin = () =>
  getGroups().findIndex((_item) => _item === "PALIKAADMIN") !== -1;
const isSuperAdmin = () =>
  getGroups().findIndex((_item) => _item === "SUPERADMIN") !== -1;
const isDistrictAdmin = () =>
  getGroups().findIndex((_item) => _item === "DISTRICTADMIN") !== -1;
const isWardAdmin = () =>
  getGroups().findIndex((_item) => _item === "WARDADMIN") !== -1;

// const getPermissions = (group = get(getGroups(), "0")) => {
//   return get(permissions, group);
// };

// const month = [
//   "January",
//   "February",
//   "March",
//   "April",
//   "May",
//   "June",
//   "July",
//   "August",
//   "September",
//   "October",
//   "November",
//   "December",
// ];

// const getMonth = (i) => month[i];

const cleanObject = (object) =>
  pickBy(
    object,
    (value, key) => !(value === undefined || value === "" || value === null)
  );

// const PrivateRoute = ({ component: Component, ...rest }) => {
//   return (
//     <Route
//       {...rest}
//       render={(props) =>
//         !!getAccessToken() ? <Component {...props} /> : <Redirect to="/login" />
//       }
//     />
//   );
// };

// This component can be extracted to a separate file later in the development process

const ProtectedComponents = (props) => {
  console.log(props, "the props");
  const isPalika = false;
  console.log(
    "the log",
    isPalikaAdmin(),
    "palika",
    isWardAdmin(),
    "isward",
    isDistrictAdmin(),
    "isdis"
  );
  return isPalikaAdmin() || isDistrictAdmin() || isWardAdmin() ? (
    props.children
  ) : (
    <Redirect to="/login" />
  );
};
class AdminProtectedComponents extends Component {
  render() {
    // If the user is not already logged in redirect him to the /login
    // For now I'm using getAccessToken() to check if the user is authenticated or not.
    // if(!isSuperAdmin()){
    //   return <Redirect to="/"/>
    // }
    return isSuperAdmin() ? this.props.children : <Redirect to="/login" />;
  }
}

export {
  getArr,
  getAccessToken,
  // PrivateRoute,
  // getGroups,
  // isStudent,
  // isTeacher,
  // isManagement,
  // isLibrarian,
  // getPermissions,
  getUser,
  ProtectedComponents,
  // getPaymentCategories,
  // cleanObject,
  // getMonth,
  isWardAdmin,
  isPalikaAdmin,
  isDistrictAdmin,
  logout,
  isSuperAdmin,
  AdminProtectedComponents,
};
